import { call, delay, put } from 'redux-saga/effects';

import { DataAction } from './EzeeAction';
import { EzeeAsyncAction } from '../helpers/EzeeAsyncAction';

export type CallableAsyncFunc<Payload> = (payload: Payload) => Promise<any>;

export function simpleAsyncSaga<Payload>(
    func: CallableAsyncFunc<Payload>,
    action: EzeeAsyncAction<any, Payload>,
) {
    return function* asyncSaga(actionData: DataAction<Payload>) {
        try {
            // console.log(actionData);
            const response = yield call(func, actionData.payload);
            return yield put(action.success(response));
        } catch (error) {
            return yield put(action.failure(error));
        }
    };
}

export function throttledSaga<Payload extends { throttling?: number}>(
    func: CallableAsyncFunc<Payload>,
    action: EzeeAsyncAction<any, Payload>,
) {
    return function* asyncSaga(actionData: DataAction<Payload>) {
        try {
            // console.log(actionData);
            yield delay(actionData.payload.throttling || 0);
            delete actionData.payload.throttling;
            const response = yield call(func, actionData.payload);
            return yield put(action.success(response));
        } catch (error) {
            return yield put(action.failure(error));
        }
    };
}
